module.exports = __webpack_public_path__ + "static/media/db.e2354795.svg";